import { CartItemList } from '@/models/cart/cart-item'
import {
  AllowPurchaseLimitUntilStock,
  AllowPurchaseUntilRestAmountOfPrice,
  AllowPurchaseUntilSkuPurchaseCountLimit,
  PurchaseCountLimitSpecification,
  TotalPurchaseCountWithSameRootMustLessThanRootPurchaseLimit,
  UseClosestRange
} from '@/models/cart/purchase-count/limit/purchase-count-limit-specification'

export class PurchaseCountLimitSpecificationPolicy {
  constructor(
    private readonly wholeCartItems: CartItemList // root購入個数制限を考慮するため、カート全体の保持も必須とする
  ) {}

  get default(): PurchaseCountLimitSpecification {
    return new UseClosestRange([
      new AllowPurchaseLimitUntilStock(),
      new AllowPurchaseUntilSkuPurchaseCountLimit(),
      new TotalPurchaseCountWithSameRootMustLessThanRootPurchaseLimit(this.wholeCartItems),
      new AllowPurchaseUntilRestAmountOfPrice(),
    ])
  }
}
